import { message, Modal } from 'antd';
import HTTP from '../../script/service';
import Util from '../../script/util';
import store from '../store';
import { ZegoExpressEngine } from 'zego-express-engine-webrtc';
import { VoiceChanger } from 'zego-express-engine-webrtc/voice-changer';
import { CopyrightedMusic } from 'zego-express-engine-webrtc/copyrighted-music';
import getZegoToken from './getZegoToken';
import { _anly_seng_custom } from '../Action';
import ZegoWebCopyrightMusic from './zegoWebCopyrightMusic';

// 拉流错误
const PLAYER_STATE_ERROR_CODE = {
  1104022: '请尝试切换或者升级浏览器后重试',
  1104023: '请尝试切换或者升级浏览器后重试',
  1104025: '请尝试切换或者升级浏览器后重试',
  1104031: '请尝试切换网络后重试',
};
// 推流错误
const PUBLISHER_STATE_ERROR_CODE = {
  1103002: '请更换或者升级浏览器',
  1103011: '获取设备列表枚举设备失败',
  1103022: '浏览器不兼容',
  1103023: '浏览器不兼容',
  1103025: '浏览器不兼容',
  1103048: '请检查该设备是否存在',
  1103051: '请尝试切换网络后重试',
  1103064: '检查是否有给本网页设备权限',
  1103065: '检查麦克风是否正在被占用',
};

const ZEGO_WEB_ERROR_CODE = {
  ...PLAYER_STATE_ERROR_CODE,
  ...PUBLISHER_STATE_ERROR_CODE,
};

class ZegoRTC {
  static instance; // 单例挂载
  client = null; // 即构实例
  isVisitor = true; // 是否是游客

  default_div = null; // 默认扬声器设备
  dev_state = null; // 扬声器状态
  default_mic = null; // 默认麦克风设备
  mic_state = true; // 麦克风状态
  mixinAudioState = false; // 伴奏状态

  disAudio = false; // 是否禁止静音

  constructor() {
    this.token = null; // 当前TOKEN
    this.client = null; // 当前实例
    this.joined = false; // 是否已加入房间
    this.published = false; // 是否正在推流中
    this.localStream = null; // 当前推流的数据
    this.remoteStreams = []; // 远程推流数据
    this.params = {}; //
    this.device_list = []; // 扬声器列表
    this.mic_list = []; // 麦克风列表
    this.liveConfig = {}; // 房间直播状态 初始化时传的
    this.speakVolume = 100; // 麦克风音量
    this.audioVolume = 100; // 伴奏音量
    this.playVolume = 100; // 扬声器音量
    this.mixinAudioDoms = new Set(); // 需要混音的伴奏dom

    this.roomUserList = []; // 当前房间用户
    this.loopFindPlayDomCount = 0; // 循环查找播放dom次数

    if (!ZegoRTC.instance) {
      ZegoRTC.instance = this;
    }
    return ZegoRTC.instance;
  }

  openConn(room) {
    this.room = room;
    this.liveConfig = room.liveConfig || {};

    this.getToken()
      .then((res) => {
        if (!this.client) {
          this.initClient(() => {
            // RTC初始化完成
            // 开始加载即构小游戏
            this.room.events['RTC_INIT_END'] && this.room.events['RTC_INIT_END'](this);

            this.setSysConfig();
            this.bindEvent();
            this.joinChannel();
            // 初始化版权音乐
            if (this.room?.baseRoomInfo?.extInfo?.ptype === 5) {
              this.CopyrightedMusic = new ZegoWebCopyrightMusic(this);
            }

            store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: true}});
          });
        } else {
          // RTC初始化完成，开始加载即构小游戏
          this.room.events['RTC_INIT_END'] &&
            this.room.events['RTC_INIT_END'](this);

          this.setSysConfig();
          this.joinChannel();
          // 初始化版权音乐
          if (this.room?.baseRoomInfo?.extInfo?.ptype === 5) {
            this.CopyrightedMusic = new ZegoWebCopyrightMusic(this);
          }

          store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: true}});
        }
      })
      .catch((err) => {
        console.error('join room error:', err);
        Modal.confirm({
          title: '提示',
          icon: null,
          closable: true,
          content: '进入当前房间失败，请重试',
          className: 'daidai-confirm-style',
          cancelText: '返回',
          okText: '确定',
          centered: true,
          onOk: () => {
            window.location.reload(true);
          },
          onCancel: () => {
            window.location.href = '/index?' + window.location.search;
          },
        });
      });
    return this;
  }

  /**
   * 获取即构的 token
   * @return {Promise}
   * */
  getToken() {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getZegoToken(this.room);
        const { token, streamIdList, userId, userName, wss } = data;
        this.token = token;
        this.zegoUser = { userID: userId, userName };
        this.server = wss;
        this.streamID = streamIdList ? streamIdList[0] : null; // 我的推流ID (游客不能推流)
        resolve(true);
      } catch (err) {
        reject(err);
      }
    });
  }

  /**
   * 初始化即构
   * */
  async initClient(callback) {
    this.remoteStreams = [];
    this.default_div = null;
    this.default_mic = null;
    this.mixinAudioState = false;
    this.dev_state = true; // 扬声器状态
    this.mic_state = true; // 麦克风状态
    this.disAudio = false; // 是否静音
    this.wifiDown = document.querySelector('#wifi-down');
    this.wifiUp = document.querySelector('#wifi-up');
    // 初始化
    const instance = await Util.getAssemblyInstance();
    const { getZegoAppID } = instance.exports;
    this.client = new ZegoExpressEngine(
      getZegoAppID(process.env.CLIENT_ENV),
      this.server
    );
    callback && callback();
  }

  /**
   * 配置即构
   * */
  setSysConfig = () => {
    // 变声插件
    ZegoExpressEngine.use(VoiceChanger);
    // 版权音乐插件
    ZegoExpressEngine.use(CopyrightedMusic);

    this.client.setDebugVerbose(false);
    this.client.setLogConfig({ logLevel: 'disable' });
    console.log('zrtcVersion', this.client.getVersion());
    this.client.setRoomScenario(6);
    this.client.setSEIConfig({ SEIPass: true });
    // 检测设备支持能力
    this.client.checkSystemRequirements('webRTC').then((ret) => {
      // todo 如果不支持 webRTC 提醒用户升级浏览器
      console.log('zrtc ret', ret);
    });
  };

  /**
   * 获取设备
   * @param {boolean} upMic 是否是上麦
   * */
  getDevices(upMic) {
    return new Promise(async (resolve, reject) => {
      // 以下两种方法都会调用麦克风权限
      if (upMic) {
        this.mic_list = await this.getDeviceMicList();
        this.device_list = await this.getDeviceSpeakersList();
        this.setDefaultDevices(upMic);
      }
      resolve(true);
    });
  }

  /**
   * 获取麦克风设备列表
   * */
  async getDeviceMicList() {
    let micList = await this.client.getMicrophones(); // 麦克风
    if (micList?.length && !!micList[0]?.deviceID) {
      // 确保返回的列表是有值的
      micList = micList.filter((n) => n.deviceID !== 'communications'); // 过滤 chrome 生成的
      micList = micList.map((n) => ({
        deviceId: n.deviceID,
        label: n.deviceName,
      }));
      return micList;
    }
    return [];
  }

  /**
   * 获取扬声器设备列表
   * */
  async getDeviceSpeakersList() {
    let deviceList = await this.client.getSpeakers(); // 扬声器
    if (deviceList?.length && !!deviceList[0]?.deviceID) {
      // 确保返回的列表是有值的
      deviceList = deviceList.filter((n) => n.deviceID !== 'communications'); // 过滤 chrome 生成的
      deviceList = deviceList.map((n) => ({
        deviceId: n.deviceID,
        label: n.deviceName,
      }));
      return deviceList;
    }
    return [];
  }

  /**
   * 设置默认设备
   * @param {boolean} upMic 是否是上麦
   * */
  setDefaultDevices(upMic) {
    // this.speakVolume = 100; // 麦克风音量默认 100
    // this.audioVolume = 100;
    // this.playVolume = 100;
    // 麦克风
    Util.setCookie('speakVolume', this.speakVolume);
    // 伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(Number(audioVolume))) {
      this.audioVolume = parseInt(audioVolume);
    }
    //扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      this.playVolume = parseInt(playVolume);
    }

    if (this.device_list.length < 1) {
      this.device_list = [
        {
          deviceId: 'default',
          label: '默认 - 线路',
        },
      ];
    }
    if (upMic && this.mic_list.length < 1) {
      message.error(
        '麦克风设备检测异常：请确麦克风/声卡设备连接正常后重试~',
        5
      );
      return;
    }

    //设置默认设备
    let def_d = Util.readCookie('default_div');
    if (def_d) {
      this.default_div = JSON.parse(def_d);
      const find = this.device_list.find(
        (n) => n.deviceId === this.default_div?.deviceId
      );
      if (find) {
        this.default_div = find;
      } else {
        this.default_div = this.device_list[0];
      }
    } else {
      this.default_div = this.device_list[0];
    }
    Util.setCookie('default_div', JSON.stringify(this.default_div));

    let def_m = Util.readCookie('default_mic');
    if (def_m) {
      this.default_mic = JSON.parse(def_m);
      const find = this.mic_list.find(
        (n) => n.deviceId === this.default_mic?.deviceId
      );
      if (find) {
        this.default_mic = find;
      } else {
        this.default_mic = this.mic_list[0];
      }
    } else {
      this.default_mic = this.mic_list[0];
    }
    Util.setCookie('default_mic', JSON.stringify(this.default_mic));
  }

  /**
   * 加入频道
   * */
  async joinChannel() {
    const that = this;
    // 每次加入默认解开
    this.room.events['CHANGE_DEV_STATE'] &&
      this.room.events['CHANGE_DEV_STATE'](false);

    if (this.room.roomid) {
      const result = await joinChannelPromise();
      if (result !== 1 && result.code) {
        if (result.code === 1002056) {
          await this.client.logoutRoom(this.room.roomid);
          await joinChannelPromise(1);
        }
      }
    } else {
      _anly_seng_custom(1112, { roomid: 'roomid is empty' });
    }

    function joinChannelPromise(retry = 0) {
      return new Promise(async (resolve) => {
        try {
          await that.client.loginRoom(
            that.room.roomid,
            that.token,
            that.zegoUser
          );
          resolve(1);
        } catch (err) {
          console.error('join room error:', err);
          _anly_seng_custom(1112, { roomid: that.room.roomid, retry, err });
          resolve(err);
        }
      });
    }
  }

  /**
   * 音频流事件监听
   * */
  bindEvent() {
    // 推流质量回调
    this.client.on('publishQualityUpdate', (streamID, stats) => {
      let vaule = Number(stats.audio.audioQuality) + 1;
      if (vaule === 6) vaule = 0;
      if (this.wifiUp) this.wifiUp.className = 'w-up d-' + vaule; // 即构与声网值相差1
    });
    // 拉流质量回调
    this.client.on('playQualityUpdate', (streamID, stats) => {
      let vaule = Number(stats.audio.audioQuality) + 1;
      if (vaule === 6) vaule = 0;
      if (this.wifiDown) this.wifiDown.className = 'w-down d-' + vaule; // 即构与声网值相差1
    });
    // 拉流状态发生变化时回调
    this.client.on('playerStateUpdate', (result) => {
      if (result?.errorCode !== 0) {
        console.error('拉流状态异常回调', result);
        // 网络错误日志不统计
        if (
          result.errorCode !== 1004020 &&
          result.errorCode !== 1104021 &&
          result.errorCode !== 1104036
        ) {
          _anly_seng_custom(1109, { data: { ...result } });
        }
      }
      if (ZEGO_WEB_ERROR_CODE[result.errorCode]) {
        const [uid] = Util.$remoteStreamToUid(result.streamID);
        if (uid) {
          message.warning(
            `${uid} 媒体播放错误, ${ZEGO_WEB_ERROR_CODE[result.errorCode]}`
          );
        }
      }
    });
    // 推流状态回调
    this.client.on(
      'publisherStateUpdate',
      ({ streamID, state, errorCode, extendedData }) => {
        if (errorCode) {
          console.error('推流状态异常回调', errorCode, state);
          // 异常数据上报
          if (errorCode === 1103044) {
            message.error('上麦异常，请刷新或联系客服', 5);
            this.delToMic(4);
          } else if (errorCode === 1103064) {
            message.error('权限异常，请给予网页麦克风权限', 5);
            this.delToMic(4);
          } else if (errorCode === 1103065) {
            message.error('麦克风被占用，无法上麦，请检查麦克风设备', 5);
            this.delToMic(4);
          } else if (ZEGO_WEB_ERROR_CODE[errorCode]) {
            message.warning(ZEGO_WEB_ERROR_CODE[errorCode], 5);
          }
          _anly_seng_custom(1108, {
            data: { streamID, state, errorCode, extendedData },
          });
        }
      }
    );
    // 音浪回调
    this.client.setSoundLevelDelegate(true, 2000); // 开启音浪回调
    this.client.on('soundLevelUpdate', (soundLevelList) => {
      soundLevelList.forEach((itemSoundLeven) => {
        const { streamID, soundLevel } = itemSoundLeven;
        let [uid, roomid] = Util.$remoteStreamToUid(streamID);
        let isSpeak = false;
        if (soundLevel > 10 && !!uid) {
          isSpeak = true;
        }
        this.room.showSpeakUsersZEGO(uid, roomid, isSpeak);
      });
    });
    // 监听音频设备状态变化
    this.client.on(
      'audioDeviceStateChanged',
      async (updateType, deviceType, deviceInfo) => {
        if (this.localStream) {
          let isShowAudioControl = 'block';
          if (updateType === 'ADD') {
            // 新增设备
            if (deviceType === 'Input') {
              // 输入
              this.mic_list = await this.getDeviceMicList();
            } else {
              // 输出
              this.device_list = await this.getDeviceSpeakersList();
            }
          } else {
            // 删除设备
            if (deviceType === 'Input') {
              // 输入
              const isDefault = this.mic_list.find(
                (item) => item.deviceId === deviceInfo.deviceID
              );
              this.mic_list = await this.getDeviceMicList();
              if (isDefault) {
                // 当删除当前输入设备时，则切换至下一个设备
                const mic = this.mic_list.find(
                  (item) => item.deviceId !== 'default'
                );
                console.log('check_mic: ', mic);
                if (!!mic) {
                  this.changeMicState({ open: this.mic_state, mic });
                } else {
                  // 如果没有设备了，则关闭麦克风 则隐藏底部麦克分
                  message.warning(
                    '您没有更多的麦克风设备，自动切换失败，请检查麦克风设备，需重新上麦'
                  );
                  isShowAudioControl = 'none';
                }
              }
            } else {
              // 输出
              this.device_list = await this.getDeviceSpeakersList();
            }
          }
          this.room.events['CHANGE_MIC_STATE'] &&
            this.room.events['CHANGE_MIC_STATE'](
              isShowAudioControl,
              this.playVolume,
              this.speakVolume
            );
        }
      }
    );
    // 设备异常回调
    this.client.on('deviceError', (errorCode, label) => {
      if (errorCode) {
        console.error('设备异常回调', errorCode, label);
        message.warning(`您的${label}设备发生异常，请检查一下该设备`, 5);
        _anly_seng_custom(1106, { data: { errorCode } });
      }
    });
    // 当房间用户发生变化时触发的回调
    this.client.on('roomUserUpdate', (roomID, updateType, userList) => {
      if (updateType === 'ADD') {
        this.roomUserList.push([...userList]);
      } else {
        userList.forEach((item) => {
          const findIndex = this.roomUserList.findIndex(
            (n) => n.userID === item.userID
          );
          if (findIndex > -1) {
            this.roomUserList.splice(findIndex, 1);
          }
        });
      }
    });
    // 房间和服务器之间的连接状态发生变化时触发的回调
    this.client.on(
      'roomStateChanged',
      async (roomID, reason, errorCode, extendedData) => {
        switch (reason) {
          case 'LOGINED':
            // 登录成功
            if (!this.room.conn) {
              _anly_seng_custom(1114, {
                data: { roomID, msg: '云信房间实例获取失败' },
              });
              await this.destroyRoom(3);
            } else {
              this.roomUserList = [];
              this.params.uid = this.room.uid;
              this.joined = true;
              this.delToMic(2);
            }
            break;
          case 'LOGIN_FAILED':
            // 登录失败
            message.warning('登录失败');
            this.joined = false;
            break;
          case 'RECONNECTING':
            break;
          case 'RECONNECTED':
            break;
          case 'RECONNECT_FAILED':
            message.error('重连失败');
            Modal.info({
              title: '系统提示',
              icon: null,
              closable: true,
              content:
                '服务器的连接因为网络原因断开了，重新连接失败，请退出房间重试。',
              className: 'daidai-confirm-style',
              cancelText: '取消',
              okText: '确定',
              centered: true,
              onOk() {
                window.location.reload();
              },
            });
            this.delToMic(4);
            break;
          case 'KICKOUT':
            await this.destroyRoom(3);
            message.error('被踢出');
            break;
          case 'LOGOUT':
            this.delToMic(2);
            break;
          default:
            break;
        }
        if (errorCode) {
          console.error(
            '========链接发生异常=======',
            errorCode,
            roomID,
            reason,
            extendedData
          );
          _anly_seng_custom(1115, {
            data: {
              token: this.token,
              roomID,
              reason,
              errorCode,
              extendedData,
            },
          });
        }
      }
    );
    // token 过期时间少于30s时会触发
    this.client.on('tokenWillExpire', async (roomID) => {
      console.error('== tokenWillExpire error==', roomID);
      this.tokenWillExpireErrorCount += 1;
      if (this?.tokenWillExpireErrorCount > 10) {
        _anly_seng_custom(1105, {
          data: {
            token: this.token,
            roomID,
            renewToken: 'true',
            count: this.tokenWillExpireErrorCount,
          },
        });

        this.tokenWillExpireErrorCount = 0;
      }
      try {
        await this.getToken();
        this.client.renewToken(this.token);
        this.tokenWillExpireErrorCount = 0;
      } catch (err) {
        _anly_seng_custom(1105, {
          data: { token: this.token, msg: '即构重连失败', err },
        });
        console.error('=======身份信息异常=======', err);
        Modal.confirm({
          title: '系统提示',
          icon: null,
          closable: true,
          content: '你的token权限失效，请退出房间重现进入。',
          className: 'daidai-confirm-style',
          cancelText: '取消',
          okText: '确定',
          centered: true,
          onOk() {
            window.location.reload();
          },
          onCancel() {
            window.location.reload();
          },
        });
      }
    });
    // 监听已登录房间内流的变化
    this.client.on(
      'roomStreamUpdate',
      async (roomID, updateType, streamList, extendedData) => {
        if (roomID === this.room.roomid) {
          streamList.forEach((stream) => {
            const [uid] = Util.$remoteStreamToUid(stream.streamID);
            if (updateType === 'ADD') {
              try {
                if (stream.streamID.indexOf('HYGame_') > -1) {
                  if (
                    this.room?.gameInteractData?.pkStatus !== 1 &&
                    this.room?.gameInteractData?.pkStatus !== 3
                  ) {
                    _anly_seng_custom(1117, {
                      data: {
                        msg: '游戏状态异常，视频流流拉取中',
                        streamID: stream?.streamID || null,
                        roundId: this.room?.gameInteractData?.roundId || null,
                        status: this.room?.gameInteractData?.pkStatus || null,
                        roomID: this.room?.roomid || null,
                        rmode: this.room?.roomInfo?.custom?.rmode || null,
                      },
                    });
                  }
                } else {
                  const domID = this.addLocalStreamDOM(stream.streamID);
                  this.client
                    .startPlayingStream(stream.streamID, {
                      video: true,
                      audio: true,
                      resourceMode: 0,
                      isSEIStart: true,
                      SEIType: 0,
                    })
                    .then((mediaStream) => {
                      const remoteStream =
                        this.client.createRemoteStreamView(mediaStream);
                      remoteStream.on('autoplayFailed', () => {
                        // 播放失败，一般为浏览器策略阻止。引导用户用手势触发恢复播放
                        document.body.addEventListener('mousedown', () =>
                          this.rePlayStreams()
                        );
                        this.room.events['LIVE_PLAY_ERROR'] &&
                          this.room.events['LIVE_PLAY_ERROR']();
                      });
                      remoteStream.on('canPlayAudio', () => {
                        remoteStream.play(domID, {
                          objectFit: 'cover',
                          enableAutoplayDialog: false,
                        });
                        remoteStream.off('canPlayAudio'); // 移除监听事件
                        const volume = !this.dev_state ? 0 : this.playVolume;
                        remoteStream.setVolume(volume);
                      });
                      remoteStream.streamID = stream.streamID;
                      this.remoteStreams.push(remoteStream);

                      this.roomStreamUpdateErrorCount = 0;
                    });
                }
              } catch (e) {
                console.error('获取媒体失败:', e);
                if (e?.errorCode && ZEGO_WEB_ERROR_CODE[e.errorCode]) {
                  message.error(
                    ZEGO_WEB_ERROR_CODE[e.errorCode] ||
                      '获取媒体失败，请稍后重试或联系客服',
                    5
                  );
                }
                if (uid == this.room.uid) {
                  // 如果当前错误状态是自己，则主动下麦
                  this.delToMic(5);
                }
                this.roomStreamUpdateErrorCount += 1;
                if (this.roomStreamUpdateErrorCount > 5) {
                  _anly_seng_custom(1101, {
                    data: {
                      error: e.toString(),
                      errorCode: e?.errorCode ?? -1,
                      message: ZEGO_WEB_ERROR_CODE[e.errorCode] || '',
                      token: this.token,
                      roomID,
                      count: this.roomStreamUpdateErrorCount,
                    },
                  });
                  this.roomStreamUpdateErrorCount = 0;
                }
              }
            } else {
              if (stream.streamID.indexOf('HYGame_') > -1) {
                this.gameInteractPlayTime &&
                  clearTimeout(this.gameInteractPlayTime);
                this.loopFindPlayDomCount = 0;
              }
              // 删除流
              this.removeLocalStreamDOM(stream.streamID);
            }
          });
        }
      }
    );
    // 房间内人数发生改变时触发
    this.client.on('roomOnlineUserCountUpdate', (roomID, count) => {
      // _dssp_send_click(114, {roomid: roomID, count})
    });
    // 房间附属消息
    this.client.on('roomExtraInfoUpdate', (roomID, roomExtraInfoList) => {
      // 游戏所用
      if (window.zegoGameHall) {
        window.zegoGameHall.roomExtraInfoUpdateCallBack(
          roomID,
          roomExtraInfoList
        );
      }
    });
  }

  startPlayGameStream = ({ publish264StreamId, publish265StreamId }) => {
    const streamID = publish264StreamId;
    // todo 互动游戏流，在互动游戏代码中拉取流
    // todo resourceMode 0 临时, 后期改为动态(2)
    this.client.startPlayingStream(streamID, {
        video: true,
        audio: true,
        resourceMode: 0,
        isSEIStart: true,
        SEIType: 0,
      })
      .then((mediaStream) => {
        this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'] && this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'](true);

        this.gameInteractStream = this.client.createRemoteStreamView(mediaStream);
        this.gameInteractStream.streamID = streamID;
        this.gameInteractStream.on('autoplayFailed', () => {
          // 播放失败，一般为浏览器策略阻止。引导用户用手势触发恢复播放
          document.body.addEventListener('mousedown', rePlayStreams);
          this.room.events['LIVE_PLAY_ERROR'] &&
            this.room.events['LIVE_PLAY_ERROR']();
        });
        this.gameInteractStream.on('canPlayAudio', () => {
          this.gameInteractPlayTime && clearTimeout(this.gameInteractPlayTime);
          this.loopFindPlayDomCount = 0;
          this.playGameInteractStream(streamID);
        });
        const that = this;
        function rePlayStreams() {
          that.gameInteractStream?.off &&
            that.gameInteractStream.off('autoplayFailed');
          if (that.gameInteractStream?.resume) {
            that.gameInteractStream.resume();
          }
          // 移除事件
          document.body.removeEventListener('mousedown', rePlayStreams);
        }
      });
  };
  stopPlayGameStream = () => {
    this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'] && this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'](false);
    if (this.gameInteractStream?.streamID) {
      this.client.stopPlayingStream(this.gameInteractStream.streamID);
    }
  };

  // 播放游戏互动流
  playGameInteractStream = (streamID) => {
    if (this.gameInteractStream) {
      const gameVideoDivDom = document.querySelector('#game-video-div');
      if (this.loopFindPlayDomCount > 5) {
        _anly_seng_custom(1116, {
          data: {
            msg: '获取播放dom失败',
            streamID: streamID || null,
            roundId: this.room?.gameInteractData?.roundId || null,
            count: this.loopFindPlayDomCount,
            status: this.room?.gameInteractData?.pkStatus || null,
          },
        });
        this.loopFindPlayDomCount = 0;
        clearTimeout(this.gameInteractPlayTime);
      } else if (gameVideoDivDom) {
        this.loopFindPlayDomCount = 0;
        clearTimeout(this.gameInteractPlayTime);
        this.gameInteractStream.play('game-video-div', {
          objectFit: 'cover',
          enableAutoplayDialog: false,
        });
        this.gameInteractStream.off('canPlayAudio'); // 移除监听事件
        const volume = !this.dev_state ? 0 : this.playVolume;
        this.gameInteractStream.setVolume(volume);
      } else {
        console.log(
          '---gameVideoDivDom null---',
          this.loopFindPlayDomCount,
          this.room?.gameInteractData?.pkStatus || null
        );
        this.loopFindPlayDomCount += 1;
        this.gameInteractPlayTime = setTimeout(() => {
          this.playGameInteractStream(streamID);
        }, 1000);
      }
    }
  };

  // 麦位镜像 - 开始拉取某条流
  startMicScreenPlayStream = (streamID, isMute = false) => {
    return new Promise((resolve, reject) => {
      this.micScreenMute = isMute;
      const domID = this.addLocalStreamDOM(streamID);
      this.client.startPlayingStream(streamID, {
        video: false,
        audio: true,
        resourceMode: 0,
        isSEIStart: true,
        SEIType: 0,
      })
        .then((mediaStream) => {
          const remoteStream = this.client.createRemoteStreamView(mediaStream);
          remoteStream.on('autoplayFailed', () => {
            // 播放失败，一般为浏览器策略阻止。引导用户用手势触发恢复播放
            document.body.addEventListener('mousedown', () =>
              this.rePlayStreams()
            );
            this.room.events['LIVE_PLAY_ERROR'] &&
            this.room.events['LIVE_PLAY_ERROR']();
          });
          remoteStream.on('canPlayAudio', () => {
            remoteStream.play(domID, {
              objectFit: 'cover',
              enableAutoplayDialog: false,
            });
            remoteStream.off('canPlayAudio'); // 移除监听事件
            const volume = isMute ? 0 : (!this.dev_state ? 0 : this.playVolume);
            remoteStream.setVolume(volume);
          });
          remoteStream.streamID = streamID;
          remoteStream.isMicScreen = true;
          this.remoteStreams.push(remoteStream);

          resolve();
        })
        .catch(reject)
    })
  }
  // 停止拉取某条流
  stopPlayStream = (streamID) => {
    this.client?.removeLocalStreamDOM?.(streamID);
  }
  // 静音麦位投屏
  muteMicScreenStream = (streamID = null) => {
    this.micScreenMute = true;
    if (streamID) {
      const find = this.remoteStreams.find((item) => item.streamID === streamID);
      if (find) {
        find.setVolume(0);
      }
    } else {
      this.remoteStreams.forEach((item) => {
        if (item.isMicScreen) {
          item.setVolume(0);
        }
      })
    }
  }
  // 取消静音麦位投屏
  unmuteMicScreenStream = (streamID = null) => {
    this.micScreenMute = false;
    if (streamID) {
      const find = this.remoteStreams.find((item) => item.streamID === streamID);
      if (find) {
        find.setVolume(!this.dev_state ? 0 : this.playVolume);
      }
    } else {
      this.remoteStreams.forEach((item) => {
        if (item.isMicScreen) {
          item.setVolume(!this.dev_state ? 0 : this.playVolume);
        }
      })
    }
  }

  /**
   * 重新播放所有音频流
   * */
  rePlayStreams() {
    this.remoteStreams.forEach((item) => {
      let volume = !this.dev_state ? 0 : this.playVolume;
      // 麦位投屏音频音量单独控制
      if (item.isMicScreen && this.micScreenMute) volume = 0;
      item.off('autoplayFailed'); // 移除监听事件
      item.resume();
      item.setVolume(volume);
    });
    // 移除事件
    document.body.removeEventListener('mousedown', () => this.rePlayStreams());
  }

  /**
   * 添加流 DOM
   * @param {string} streamID 流ID
   * */
  addLocalStreamDOM(streamID) {
    const [uid] = Util.$remoteStreamToUid(streamID);
    const id = `remote_stream_${uid}`;
    if (!document.querySelector(id)) {
      let element = document.createElement('div');
      element.id = id;
      document.querySelector('#local_stream').appendChild(element);
    }
    return id;
  }

  /**
   * 删除音频流
   * @param {string} streamID 流ID
   * @param {boolean} isStopPlay 是否停止拉流
   * */
  removeLocalStreamDOM = (streamID, isStopPlay = true) => {
    const [uid] = Util.$remoteStreamToUid(streamID);
    const id = `remote_stream_${uid}`;
    if (!!isStopPlay) {
      try {
        this.client.stopPlayingStream(streamID);
      } catch (e) {
        console.error('停止音频流失败', streamID);
        _anly_seng_custom(1102, { data: { msg: '停止音频流失败', err: e } });
      }
    }
    const findIndex = this.remoteStreams.findIndex(
      (n) => n.streamID === streamID
    );
    findIndex > -1 && this.remoteStreams.splice(findIndex, 1); // 删除数组中的流对象
    this.deleteReview(id);
  };

  /**
   * 移除远程流 DOM
   * @param {string|null} id 需要移除的 DOM
   * */
  deleteReview(id) {
    const dom = document.querySelector('#local_stream');
    if (dom == null) return;
    if (id == null) {
      dom.innerHTML = ''; // 清空DOM，防止 Agora 异常
    } else {
      let element = document.querySelector(`#${id}`);
      if (element && dom?.removeChild) {
        dom.removeChild(element);
      }
    }
  }

  /**
   * 创建本地流
   */
  async createLocalStream(callback) {
    try {
      // 先关闭本地流
      if (this.localStream) {
        // 如果伴奏还在播放提示
        if (this.mixinAudioState) {
          this.changeMixingAudio(false); // 关闭所有混音 - 关闭伴奏
          message.warning(
            '麦克风被切换，伴奏播放被中断。需要手动重新开启。',
            5
          );
        }
        // 1. 关闭麦克风设备
        await this.changeMicState({ open: this.mic_state, mic: null });
        // 2. 禁止推流
        this.changeRoleToAudience();
        this.localStream = null;
        this.mixinAudioState = false;
        // 如果原来的伴奏还是开启状态
        this.room.events['CHANGE_AUDIO_STATE'] &&
          this.room.events['CHANGE_AUDIO_STATE'](1, this.audioVolume);
      }
      const config = {
        camera: {
          audio: true,
          video: false,
          audioBitrate: 128,
          channelCount: 2,
          AEC: false,
        },
        screen: false,
      };
      // 1. 创建
      this.localStream = await this.client.createStream(config);
      // 2. 推流
      this.changeRoleToPlayer();
      callback && callback();
    } catch (e) {
      console.warn('创建流失败：', e);
      _anly_seng_custom(1103, { data: { msg: '创建流失败', err: e } });
      if (e?.code === 1103044) {
        message.error('上麦异常，请刷新或联系客服', 5);
        this.delToMic(4);
      } else if (e?.code === 1103064) {
        message.error('权限异常，请给予网页麦克风权限', 5);
        this.delToMic(4);
      } else if (e?.code === 1103065) {
        message.error('麦克风被占用，无法上麦，请检查麦克风设备', 5);
        this.delToMic(4);
      } else if (ZEGO_WEB_ERROR_CODE[e?.code]) {
        message.warning(ZEGO_WEB_ERROR_CODE[e?.code], 5);
      }
    }
  }

  /**
   * 更新直播队列
   * */
  getLiveConfig(callback) {
    //直播上报
    HTTP._mixed_channel_create({
      uid: this.room.uid,
      roomid: this.room.roomid,
      roomcid: this.room.roomid,
      creator: this.room.account,
    });
    const { rootConfig } = store.getState();
    //如果直播已经存在
    if (this.room.hasLive()) {
      this.liveConfig = {
        channelName: this.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: this.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: this.room.base.clientInfo.version, //pc独有版本参数
        master_type: this.room.base.client, //主播当前终端类型
        config: [...this.room.liveConfig.config], //麦位属性配置
      };
    } else {
      this.liveConfig = {
        channelName: this.room.roomid, //房间名称
        channelId: null, //通话渠道 由网易返回
        creator: this.room.account, //直播创建者
        cid: null, //通话cid标识 由接口返回
        pushUrl: null, //推流地址
        rtmpPullUrl: null, //拉流地址
        web_version: rootConfig.version, //网页独有版本参数
        pc_version: this.room.base.clientInfo.version, //pc独有版本参数
        master_type: this.room.base.client, //主播当前终端类型
        config: [], //麦位属性配置
      };
      for (let i = 0; i < 9; i++) {
        this.liveConfig.config.push({
          index: i, //麦位
          type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
          enabled: true, // 是否启用用位置
          microphone: true, // 是否启用麦克风
          disAudio: false, //是否静音
        });
      }
    }
    //2、发送麦位配置
    this.room.modifyConfig(this.liveConfig, false, () => {
      //3、发送1-1指令
      this.room.sendCustomMsg({
        action: '1-1',
        creator: this.room.account,
      });
      callback && callback();
    });
  }

  /**
   * 验证浏览器是否符合开启标准
   * */
  viliDataAutioText() {
    if (!this.audioContext) {
      // @ts-ignore
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
    }
    if (!this.audioContext) {
      message.error(
        '你的浏览器不支持伴奏功能，请使用最新版本Chrome浏览器/下载客户端',
        5
      );
      return false;
    }
    let version = parseInt(this.getBrowser('v'));
    let name = this.getBrowser('n');
    //81内核之前，不允许使用大于48000的采样率
    if (name != 'chrome') return true;
    if (version >= 81) return true;
    if (this.audioContext.sampleRate <= 48000) return true;
    return false;
  }

  /**
   * 获取浏览器版本
   * @param {string} n 需要的字段
   * */
  getBrowser(n) {
    /* eslint-disable */
    var ua = window.navigator.userAgent.toLowerCase();
    var s = null;
    var name = '';
    var ver = 0;
    //探测浏览器
    (s = ua.match(/msie ([\d.]+)/))
      ? _set('ie', _toFixedVersion(s[1]))
      : (s = ua.match(/firefox\/([\d.]+)/))
        ? _set('firefox', _toFixedVersion(s[1]))
        : (s = ua.match(/chrome\/([\d.]+)/))
          ? _set('chrome', _toFixedVersion(s[1]))
          : (s = ua.match(/opera.([\d.]+)/))
            ? _set('opera', _toFixedVersion(s[1]))
            : (s = ua.match(/version\/([\d.]+).*safari/))
              ? _set('safari', _toFixedVersion(s[1]))
              : 0;

    function _toFixedVersion(ver, floatLength) {
      ver = ('' + ver).replace(/_/g, '.');
      floatLength = floatLength || 1;
      ver = String(ver).split('.');
      ver = ver[0] + '.' + (ver[1] || '0');
      ver = Number(ver).toFixed(floatLength);
      return ver;
    }

    function _set(bname, bver) {
      name = bname;
      ver = bver;
    }

    /* eslint-enable*/
    return n == 'n' ? name : n == 'v' ? ver : name + ver;
  }

  /**
   * 加入房间成功
   * */
  joinSuccess(callback) {
    this.published = true;
    this.room.queuePoll(`queue_${this.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      this.room.roomInfo &&
      this.room.roomInfo.custom &&
      this.room.roomInfo.custom.rmode == 1 &&
      this.room.datingData &&
      this.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: this.room.roomid,
        uids: this.room.uid,
      });
    }
    if (this.room.base.microType === 0) {
      if (this.room.roomInfo && this.room.roomInfo.custom) {
        let meque = this.room.queueObject[this.room.account];
        let msgId = null;
        if (
          this.room.roomInfo.custom.rmode == 6 &&
          this.room.sendOrders &&
          this.room.sendOrders.msgId
        ) {
          msgId = this.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: this.room.uid,
            roomId: this.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }
    callback && callback();
  }

  /**
   * 设置扬声器音量
   * @param {number} volume 音量
   * @param {function} callback 回调是否可以调节音量
   * */
  setPlayVolume = (volume, callback = null) => {
    if (this.isGameing && this.isGameOperateSpeaker) {
      message.warning('游戏中无法调节扬声器音量');
      callback && callback(false);
      return;
    }
    this.dev_state = true;
    Util.setCookie('playVolume', volume);
    this.playVolume = volume;
    this.rePlayStreams();
    callback && callback(true);
  };
  /**
   * 开启本地扬声器设备
   * @param {boolean} open 是否开启扬声器
   * @param {ZegoDeviceInfo} dev 设备ID
   * @param {boolean} operateSource 操作来源是否是游戏 true：来自游戏，可以操作， false：来自用户，不可以操作
   * */
  changeVoiceState = async ({
    open,
    dev = null,
    operateSource = false,
    callback = () => {},
  }) => {
    if (!this.client) return false;
    if (this.isGameing && this.isGameOperateSpeaker && !operateSource && open) {
      message.warning('游戏中不允许切换扬声器状态');
      return false;
    }
    this.isGameOperateSpeaker = operateSource;
    this.dev_state = open;
    // 改变扬声器图标
    this.room.events['CHANGE_DEV_STATE'] &&
      this.room.events['CHANGE_DEV_STATE'](!this.dev_state);
    // 存储 cookie
    if (dev) {
      let oldId = this.default_div ? this.default_div.deviceId : null;
      if (this.localStream && dev?.deviceId !== oldId) {
        // todo 配置扬声器
        const mediaDom = document.querySelector('#music_dom');
        this.default_div = dev;
        Util.setCookie('default_div', JSON.stringify(this.default_div));
        const ret = await this.client.useAudioOutputDevice(
          mediaDom,
          this.default_div.deviceId
        );
        if (ret) {
          this.room.events['CHANGE_DEV_SELECT'] &&
            this.room.events['CHANGE_DEV_SELECT'](this.playVolume);
        } else {
          message.error(`切换扬声器失败，请重试: ${ret.toString()}`);
        }
      }
    }
    this.rePlayStreams();
    callback && callback();
  };
  /**
   * 开启本地麦克风设备
   * @param {boolean} open 麦克风状态
   * @param {ZegoDeviceInfo} mic 切换所需的麦克风
   * @param {boolean} isRefresh 强制设置麦克风设备
   * @param {boolean} operateSource 操作来源是否是游戏 true：来自游戏，可以操作， false：来自用户，不可以操作
   * @param {boolean} isGameOperate 是否是游戏操作
   * */
  changeMicState = async ({
    open,
    mic = null,
    isRefresh = false,
    operateSource = false,
    callback = () => {},
  }) => {
    if (!this.client) return false;
    if (this.isGameing && this.isGameOperateMic && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return false;
    }
    this.isGameOperateMic = operateSource;
    this.mic_state = open;
    // 改变麦克风图标
    this.room.events['CHANGE_MIC_STATUS'] &&
      this.room.events['CHANGE_MIC_STATUS'](!this.mic_state);
    if (this.localStream) {
      if (this.mic_state) {
        this.client.mutePublishStreamAudio(this.localStream, false);
      } else {
        this.client.mutePublishStreamAudio(this.localStream, true);
      }
    }
    if (mic) {
      let oldId = this.default_mic ? this.default_mic.deviceId : null;
      if ((this.localStream && mic?.deviceId !== oldId) || isRefresh) {
        this.default_mic = mic;
        const ret = await this.client.useAudioDevice(
          this.localStream,
          this.default_mic.deviceId
        );
        Util.setCookie('default_mic', JSON.stringify(this.default_mic));
        if (ret?.errorCode === 0) {
          this.room.events['CHANGE_MIC_SELECT'] &&
            this.room.events['CHANGE_MIC_SELECT']();
        } else {
          if (ret?.errorCode) {
            ZEGO_WEB_ERROR_CODE[ret.errorCode] &&
              message.error(
                `切换麦克风失败，请重试: ${ZEGO_WEB_ERROR_CODE[ret.errorCode]}`
              );
            _anly_seng_custom(1106, {
              data: { msg: '切换麦克风失败', err: ret },
            });
          }
        }
      }
    }
    callback && callback();
  };
  /**
   * 设置采集音量（麦克风音量）
   * @param {number} volume 音量
   * @param {boolean} isSourceClickMusic 是否来源于点唱控台
   * */
  setSpeakVolume = (
    volume = 100,
    isSourceClickMusic = false,
    callback = null
  ) => {
    if (this.isGameing && this.isGameOperateMic) {
      message.warning('游戏中无法调节麦克风音量');
      callback && callback(false);
      return;
    }
    if (isNaN(volume)) volume = 100;
    volume = Number(volume);
    if (volume > 100) volume = 100;
    if (volume < 0) volume = 0;

    this.mic_state = true;
    this.speakVolume = volume;
    Util.setCookie('speakVolume', volume);
    this.changeMicState({ open: this.mic_state });
    this.client.setCaptureVolume(this.localStream, volume);

    // 点唱房控制台可以修改麦克风音量
    if (isSourceClickMusic) {
      this.room.events['CHANGE_MIC_VOLUME'] &&
        this.room.events['CHANGE_MIC_VOLUME'](volume);
    }
    callback && callback(true);
  };
  /**
   * 添加需要混音的 DOM ID
   * @param {string|[string]} id DOM ID
   * */
  addMixingAudioID = (ids) => {
    if (Array.isArray(ids)) {
      ids.forEach((id) => this.mixinAudioDoms.add(id));
    } else {
      this.mixinAudioDoms.add(ids);
    }
  };
  /**
   * 开始混音
   * @param {boolean} open 是否开始混音
   * @param {Array<HTMLMediaElement>} mediaList 混音挂在的音频DOM
   * @returns {boolean|null} 是否开启混音
   * */
  changeMixingAudio = (open, mediaList = []) => {
    if (!this.localStream) return null;
    this.mixinAudioState = open;
    if (open) {
      let bool = this.viliDataAutioText();
      if (bool) {
        const doms = [];
        this.mixinAudioDoms.forEach((id) => {
          const dom = document.querySelector(id);
          if (dom) {
            doms.push(dom);
          }
        });
        this.client.startMixingAudio(this.streamID, doms);
      } else {
        message.error(
          '你的电脑无法支持高频采样率，请在电脑右下角点击：声音 > 属性 > 扬声器 > 属性 > 高级 > 中设置为48000Hz',
          5
        );
        return null;
      }
    } else {
      if (mediaList) {
        this.client.stopMixingAudio(this.streamID, mediaList);
      } else {
        this.client.stopMixingAudio(this.streamID);
      }
    }
    return this.mixinAudioState;
  };
  /**
   * 默认伴奏混音音量
   * @param {boolean} open 是否开始混流
   * @param {HTMLMediaElement} musicDom 混流挂在的音频DOM
   */
  changeAudioDefaultVolume = (open, musicDom) => {
    if (!this.localStream) return;
    this.setAudioVolume(this.audioVolume, musicDom);
  };
  /**
   * 设置伴奏音量
   * @param {number} volume 伴奏音量
   * @param {HTMLMediaElement} media 伴奏挂载的 DOM 节点
   * @param {boolean} mute 是否是静音
   * */
  setAudioVolume = (volume, media, mute) => {
    if (!this.localStream) return false;
    const dom = document.querySelector(media);
    if (mute) {
      if (this.mixinAudioState) {
        // 只有当伴奏是开启的状态时才会修改
        this.client.setMixingAudioVolume(this.streamID, 0, dom);
      }
      this.audioVolume = 0;
      return true;
    }
    if (volume < 0) volume = 0;
    if (volume > 100) volume = 100;
    if (this.mixinAudioState) {
      // 只有当伴奏是开启的状态时才会修改
      this.client.setMixingAudioVolume(this.streamID, volume, dom);
    }
    Util.setCookie('audioVolume', volume);
    this.audioVolume = volume;
    return true;
  };

  /**
   * 上麦
   * @param {Object} queue 麦序信息
   */
  async publishLocalStream(queue) {
    if (this.slefStream) return;
    return new Promise(async (resolve, reject) => {
      this.index = queue.index;
      this.slefStream = true;
      await this.getDevices(true);
      if (!this.mic_list.length) {
        this.slefStream = false;
        this.room.closeLoading && this.room.closeLoading();
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。',
          5
        );
        if (queue.index === 0) {
          // 主持人必须要有麦克分权限
          this.delToMic(4);
        }
        return;
      }
      // 1. 创建自己的流
      this.createLocalStream(async () => {
        // 2. 获取设备
        await this.getDevices(true);
        await this.changeMicState({
          open: this.mic_state,
          mic: this.default_mic,
          isRefresh: true,
        });
        // 更新直播队列
        if (this.index == 0) {
          this.getLiveConfig(() => {
            // 4. 上报
            this.joinSuccess(resolve);
          });
        } else {
          // 4. 创建自己的队列
          this.joinSuccess(resolve);
        }
        // 初始化设置一次扬声器
        this.changeVoiceState({ open: true, dev: this.default_div });
        // 创建版权音乐媒体容器
        if (this.CopyrightedMusic) {
          this.CopyrightedMusic.createMusicMedia();
        }
        this.speakVolume = 100; // 重置麦克风音量
        // 扬声器状态回调
        this.room.events['CHANGE_MIC_STATE'] &&
          this.room.events['CHANGE_MIC_STATE'](
            'block',
            this.playVolume,
            this.speakVolume
          );
        // 显示伴奏状态
        this.room.events['CHANGE_AUDIO_STATE'] &&
          this.room.events['CHANGE_AUDIO_STATE'](true, this.audioVolume);
      });
    });
  }

  /**
   * 踢TA下麦 - 我自己下麦
   * */
  delToMic(n) {
    // 麦克风状态回调
    this.room.events['CHANGE_MIC_STATE'] &&
      this.room.events['CHANGE_MIC_STATE'](
        'none',
        this.playVolume,
        this.speakVolume
      );
    // 关闭伴奏状态
    this.room.events['CHANGE_AUDIO_STATE'] &&
      this.room.events['CHANGE_AUDIO_STATE'](false);
    console.log(`--------${n}--------`);
    this.mic_state = true; // 重置麦克风状态
    // 关闭存在本地流
    if (this.localStream) {
      // 1. 关闭混音
      if (this.CopyrightedMusic) {
        this.CopyrightedMusic.destroyMedia();
      }
      this.changeMixingAudio(false, null);
      // 1. 关闭推流
      this.changeRoleToAudience();
      this.client.destroyStream(this.localStream); // 销毁创建的流数据
      this.localStream = null;
      this.published = false;
      this.playMusicIng = false;
      this.slefStream = false;
      const dom = document.querySelector('#local_video');
      if (dom) dom.innerHTML = '';
      this.mixinAudioDoms.clear(); // 清空传入的伴奏DOM
    }
    // 删除自己的队列
    if (this.room.hasQueume()) {
      const { microType } = store.getState();
      if (microType === 0) {
        this.room.queuePoll(this.room.account);
      } else {
        HTTP._post_server_down_microphone({
          roomId: this.room.roomid,
          operationType: 0,
        });
      }
    }
    this.room.events['CHANGE_MIC_GAME_OVER'] &&
      this.room.events['CHANGE_MIC_GAME_OVER'](n);
  }

  /**
   * 发言
   */
  changeRoleToPlayer() {
    try {
      this.client.startPublishingStream(this.streamID, this.localStream, {
        isSEIStart: true,
        SEIType: 0,
      });
      this.published = true;
      this.disAudio = false;
    } catch (err) {
      console.warn('发言接口异常:', err);
      _anly_seng_custom(1113, { data: { err } });
    }
  }

  /**
   * 闭麦
   */
  changeRoleToAudience() {
    this.streamID && this.client.stopPublishingStream(this.streamID);
    this.published = false;
    this.disAudio = true;
  }

  /**
   * 销毁离开房间
   * */
  async destroyRoom(n) {
    this.room.webrtc = null;
    this.delToMic(3);
    let dom = document.querySelector('#local_video');
    if (!this.joined) {
      this.localStream = null;
      this.remoteStreams = [];
      if (dom) dom.innerHTML = '';
      this.deleteReview(null);
      return;
    }

    // todo 退出房间通过监听的方式移除执行一下操作
    console.log('destroyRoom：', n);
    this.joined = false;
    this.changeRoleToAudience();
    this.localStream = null;
    this.published = false;
    this.playMusicIng = false;
    // 停止互动游戏视频拉流
    if (this.gameInteractStream?.streamID) {
      this.client.stopPublishingStream(this.gameInteractStream.sreamID);
    }
    this.gameInteractStream = null;
    // 停止拉流
    while (this.remoteStreams.length > 0) {
      const stream = this.remoteStreams.shift();
      stream.stop();
    }
    this.remoteStreams = [];
    // 销毁版权音乐
    if (this.CopyrightedMusic) {
      this.CopyrightedMusic.destroy();
    }
    //清空一次本地播放器
    if (dom) dom.innerHTML = '';
    this.deleteReview(null);
    this.client.logoutRoom(this.room.roomid);
    // 关闭底部菜单操作栏
    this.room.events['CHANGE_MIC_STATE'] &&
      this.room.events['CHANGE_MIC_STATE'](
        'none',
        this.playVolume,
        this.speakVolume
      );
    // 关闭伴奏状态
    this.room.events['CHANGE_AUDIO_STATE'] &&
      this.room.events['CHANGE_AUDIO_STATE'](false);

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: false}});
  }

  /**
   * 设置变声/美声
   * @param {number} type 变声数值，预设
   *        0 正常
   *        1 男声变童声
   *        2 男声变女声
   *        3 女声变童声
   *        4 女声变男声
   *        6 擎天柱声效
   *        7 机器人声效
   *        8 空灵声效
   *        9 磁性男 - 美声
   *        10 清新女 - 美声
   *        11 C 大调电音 - 电音
   *        12 A 小调电音 - 电音
   *        13 和声小调电音 - 电音
   *        14 女活力音效 - 美声
   * */
  setAudioEffectPreset = (type = 0) => {
    this.client.setVoiceChangerPreset(type, this.localStream);
  };

  /***
   * 游戏方操作闭麦开麦
   * */
  gameOperateRTC = {
    syncGameStatus: (bool = false) => {
      this.isGameing = bool;
      if (!bool) {
        this.isGameOperateMic = false;
        this.isGameOperateSpeaker = false;
      }
    },
    // 开麦
    openMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: true, operateSource: true });
      }
    },
    // 闭麦
    closeMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: false, operateSource: true });
      }
    },
    // 开启扬声器
    openSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: true, operateSource: true });
      }
    },
    // 关闭扬声器
    closeSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: false, operateSource: true });
      }
    },
  };
}

const zegoRTC = new ZegoRTC();

export default zegoRTC;
